import { IUserToken } from '@module/authentication/models';
import { licenseAllowanceReducer, serverReducer, serviceOptionsReducer } from '@module/license';
import { registerSiteReducer } from '@module/registerSite/reducers';
import { sitesReducer } from '@module/site/reducers';
import { IUser } from '@module/userManagement';
import { userSearchReducer } from '@module/userManagement/reducers';
import { combineReducers } from 'redux';

const initialUserState: IUserState = {
  loggedInUser: null,
  userPermissions: null
};

export interface IConnectedComponent {
  history: any;
  dispatch: any;
  loggedInUser: IUserToken;
  userPermissions: IUser;
}

export interface IAuthenticationProps {
  login: (user: any) => Promise<void>;
  logout: (user: any) => void;
  tokenExpired: () => void;
  children: any;
  context: any;
}

export const reducers = combineReducers({
  userState: userReducer,
  serverState: serverReducer,
  servicesState: licenseAllowanceReducer,
  serviceOptionsState: serviceOptionsReducer,
  sitesState: sitesReducer,
  registerState: registerSiteReducer,
  userFilter: userSearchReducer
});

interface IUserState {
  loggedInUser: IUserToken | null;
  userPermissions: IUser | null;
}

function userReducer(state = initialUserState, action: any): IUserState {
  switch (action.type) {
    case 'USER_LOGIN':
      return { ...state, loggedInUser: action.loggedInUser, userPermissions: action.userPermissions};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/reducers.ts